module.exports = __webpack_public_path__ + "img/08.dc359b45.jpg";